import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import CycleProgram from "./cycle-program";
import submit from "submit-form";
import getViewInCalendarMonth from "../../utils/get-view-month";
import ToolTip from "../tooltip";

import getCycleCardImagePath from "../../utils/get-cycle-card-image-path";
import { isPushActiveCoach } from "../../utils/user-helpers";
import SvgIcon from "../SvgIcon";
import ImgComponent from "../ImgComponent";

// Used in program library and program-builder landing page.

const calculateIfMostPopular = (activeUserToRequest, cycleId, storeType) => {
  const mostPopularName = {
    programs: "mostPopular",
    "single-workout": "mostPopularSingle",
  };

  return (
    activeUserToRequest.pushAccountInfo &&
    activeUserToRequest.pushAccountInfo[mostPopularName[storeType]] &&
    activeUserToRequest.pushAccountInfo[mostPopularName[storeType]] === cycleId
  );
};
class CycleCard extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      expanded: false,
      storeSubmited: false,
      blockSubmited: false,
      imgError: false,
    };
    this.prefix = this.props.cycle._id.substr(-5);
    this.toggleTags = this.toggleTags.bind(this);
    this.copyToStore = this.copyToStore.bind(this);
    this.imageerror = this.imageerror.bind(this);
  }

  toggleTags() {
    this.setState({ expanded: !this.state.expanded });
  }

  copyToStore(e, cycle) {
    e.stopPropagation();
    e.preventDefault();
    const confirm = window.confirm(
      "Are you sure you want to copy this program to the store?"
    );
    if (!confirm) {
      this.setState({ storeSubmited: false });
      return;
    }

    this.setState({ storeSubmited: true });

    submit(`/actions/cycle/store/${cycle._id}`, {
      method: "GET",
    });
  }

  handleDeleteCycle(e) {
    e.preventDefault();
    submit(`/actions/cycle/delete-cycle/${this.props.cycle._id}`, {
      method: "GET",
    });
  }

  imageerror() {
    this.setState({ imgError: true });
  }
  render() {
    const {
      cycle,
      cardIndex,
      isTemplate,
      isSubscription,
      isSubscriptionPublished,
    } = this.props;

    const image = getCycleCardImagePath(cycle);

    const style = cycle.type === "premium" ? "alt-premium" : "alt-mine";
    const {
      activeUser,
      activeUserToRequest,
      query = {},
      athlete,
      heading,
    } = this.context.locals;
    const isFe = Boolean(activeUserToRequest.pushAccountInfo);
    const referAsClients = Boolean(activeUser.referAsClients);

    // Determine what "View in calendar" should do
    let viewInCalendarMonth,
      isUnscheduled,
      publishedProgramsOrders = [];
    if (cycle.programs.length) {
      const programProgresses = cycle.programs.map((program) => {
        // take advantage of this iteration to populate published programs orders.
        if (program.status === "published")
          publishedProgramsOrders.push(program.order);
        return program.progress;
      });
      isUnscheduled = programProgresses.every(
        (status) => status === "Unscheduled"
      );
      if (!isUnscheduled) {
        let programToView = cycle.programs.find(
          (program) => program.progress === "In Progress"
        );
        if (!programToView)
          programToView = cycle.programs.find(
            (program) => program.progress === "Upcoming"
          );
        if (!programToView)
          programToView = cycle.programs.find(
            (program) => program.progress === "Completed"
          );
        viewInCalendarMonth = programToView
          ? getViewInCalendarMonth(
              programToView.progress,
              programToView.instances,
              this.context.locals.momentTZ
            )
          : "";
      }
    }

    const isPushed = cycle.status === "pushed";
    const isCoach = cycle.type === "coach";
    const inCoachMode =
      isCoach &&
      String(cycle.createdBy._id) === String(activeUserToRequest._id) &&
      heading !== "Program Builder";
    const fromProgramLibrary = cycle && isSubscriptionPublished;
    // cycle is created by user and auth user is the owner
    const userMode =
      cycle.type === "user" && cycle.createdBy._id === activeUserToRequest._id;
    const typeCard = isTemplate ? "Template" : "Program";

    let organizationQuery = ``;

    if (query.organizationCoach) {
      organizationQuery = `&organizationCoach=${query.organizationCoach}`;
    }

    const parentPath = query.athlete
      ? "/athlete-portal/programs"
      : isSubscription
      ? "/coaching-portal/store"
      : isTemplate
      ? "/coaching-portal/templates"
      : "/dashboard/program-builder";

    let previewPath = `${parentPath}/program-preview/${cycle._id}?program=1`;
    let addToCalenderPath = `/actions/refresh?modal[type]=add-to-calendar&cycleId=${cycle._id}&wholeCycle=true`;
    if (athlete)
      previewPath =
        `${previewPath}&athlete=${athlete && athlete._id}` + organizationQuery;

    const ListIcon = [
      {
        id: `preview-program`,
        src: "/img/new-icons/eye.svg",
        alt: "preview",
        message: `Preview ${typeCard}`,
        url: previewPath,
        show: (!isUnscheduled && cycle.programs.length) || isSubscription,
        colorClass: "icon-green",
      },
      {
        id: "fetch-block",
        src: "/img/new-icons/copy-from.svg",
        alt: "fetch",
        message: "Copy Block From",
        url: `/actions/refresh?modal[type]=fetch&destinationCycleId=${cycle._id}&destinationCycleName=${cycle.name}&destinationCycleStatus=${cycle.status}`,
        show: true,
        colorClass: "icon-magenta copy-block",
      },
      {
        id: "copy-program",
        src: "/img/new-icons/copy-to.svg",
        alt: "fetch",
        message: `Copy ${typeCard} to`,
        url: `/actions/refresh/?modal[type]=send&cycleId=${cycle._id}`,
        show: !isTemplate && !isSubscription,
        colorClass: "icon-blue copy-to",
      },
      {
        id: "duplicate",
        src: "/img/new-icons/duplicate.svg",
        alt: "duplicate",
        message: `Duplicate ${typeCard}`,
        url: `/actions/cycle/duplicate/${cycle._id}${
          isSubscription ? "?store=true" : ""
        }`,
        show: true,

        showForUser: true,
      },
      {
        id: `program-settings`,
        src: "/img/new-icons/settings.svg",
        alt: "view",
        message: `${typeCard} Settings`,
        url: `/actions/refresh?modal[type]=edit-cycle-settings&cycleId=${cycle._id}`,
        show: (!fromProgramLibrary && !isPushed) || isSubscription,

        showForUser: true,
      },
      {
        id: "delete-program",
        src: "/img/new-icons/red-trash.svg",
        alt: "delete",
        message: `Delete ${typeCard}`,
        url: `/actions/cycle/delete-cycle/${cycle._id}/?isFromCoachingPortal=${
          inCoachMode || isSubscription
        }`,
        show: isCoach || isSubscription || userMode,
        showForUser: true,
        colorClass: "icon-red",
      },
    ];

    const numberOfWeeks = cycle.totalNumberOfWeeks;

    const isMostPopular = calculateIfMostPopular(
      activeUserToRequest,
      cycle._id,
      cycle.storeType || "programs"
    );

    const notSingleWorkout = cycle.storeType !== "single-workout";

    return (
      <article
        className={`column ${
          !notSingleWorkout && isFe && isSubscriptionPublished ? "!pb-0" : ""
        }`}
        data-col="1/3"
        id={cycle._id}
      >
        <div className={`Cycle-Builder-Preview ${style}`}>
          <div
            className={`image${this.state.imgError ? " error" : ""}`}
            onClick={() => {
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: {
                  "modal[type]": "learn-more",
                  cycleId: cycle._id,
                },
              });
            }}
          >
            <ImgComponent
              image={image}
              classNames={`program-image ${
                image.startsWith("data:image") ? "no-image" : ""
              }`}
              altText="program thumbnail"
              onErrorFn={this.imageerror}
            />
          </div>
          {Boolean(cycle.programs.length) &&
            !inCoachMode &&
            !isSubscription && (
              <a
                role="button"
                data-button-type="secondary"
                className="m-4 gap-2"
                href={`/actions/refresh?modal[type]=add-to-calendar&cycleId=${cycle._id}&wholeCycle=true`}
              >
                <SvgIcon src="/img/new-icons/calendar-ico.svg" />
                Add to Calendar{" "}
              </a>
            )}
          {!!(
            (cycle.programs && cycle.programs.length && isTemplate) ||
            isFe & isSubscriptionPublished
          ) && (
            <>
              <header>
                {cycle.programs &&
                cycle.programs.length &&
                ((isFe &&
                  isPushActiveCoach(activeUserToRequest) &&
                  isTemplate) ||
                  (!isFe && isCoach && isTemplate)) ? (
                  <button
                    data-button-type="secondary"
                    onClick={(event) => {
                      event.stopPropagation();
                      submit(`/actions/refresh/?`, {
                        method: "GET",
                        body: {
                          "modal[type]": "send",
                          cycleId: cycle._id,
                        },
                      });
                    }}
                  >
                    <SvgIcon
                      src="/img/new-icons/user-circle.svg"
                      alt="message"
                    />
                    Copy to {referAsClients ? "client" : "athlete"}
                  </button>
                ) : null}
                {isFe &&
                  cycle.programs &&
                  cycle.programs.length &&
                  isTemplate && (
                    <button
                      data-button-type="secondary"
                      onClick={(event) => {
                        this.copyToStore(event, cycle);
                      }}
                    >
                      <SvgIcon
                        src="/img/new-icons/shopping-bag.svg"
                        alt="cStore"
                      />
                      Copy to store
                    </button>
                  )}
              </header>
            </>
          )}
          <div className="details">
            <CycleHeader
              cycle={cycle}
              isSubscriptionPublished={isSubscriptionPublished}
            />

            {notSingleWorkout && (
              <div className="sessions">
                <ul>
                  {cycle.sessionsPerWeek && (
                    <li>{cycle.sessionsPerWeek} sessions per week</li>
                  )}
                  <li>
                    {`${numberOfWeeks} `}
                    week{numberOfWeeks > 1 ? "s" : ""}
                  </li>
                </ul>
              </div>
            )}
            {notSingleWorkout && (
              <CycleTags
                cycle={cycle}
                state={this.state}
                toggleTags={this.toggleTags}
              />
            )}

            {!isSubscriptionPublished && notSingleWorkout && (
              <ul
                className={`programs ${
                  cycle.programs.length < 4 ? "alt-short" : ""
                }`}
                ref="programs"
                data-id={cycle.id}
                data-published-programs={publishedProgramsOrders}
              >
                {cycle.programs.map((program, programIndex) => {
                  return (
                    <CycleProgram
                      key={`${cycle._id}-program-${programIndex}`}
                      program={program}
                      programIndex={programIndex}
                      cycle={cycle}
                      cardIndex={cardIndex}
                      parentPath={parentPath}
                      status={cycle.status}
                      type={cycle.type}
                      athlete={athlete}
                      isTemplate={isTemplate}
                      inCoachMode={inCoachMode}
                      isCoach={isCoach}
                      isSubscription={isSubscription}
                      isSubscriptionPublished={isSubscriptionPublished}
                      fromProgramLibrary={fromProgramLibrary}
                      locals={this.context.locals}
                    />
                  );
                })}
              </ul>
            )}

            {!notSingleWorkout && (
              <ul
                className={`programs alt-short ${
                  isFe && isSubscriptionPublished ? "!max-h-[unset]" : ""
                }`}
                ref="programs"
                data-id={cycle.id}
                data-published-programs={publishedProgramsOrders}
              >
                <li className="tr-Cycle-Program-Item">
                  <div className={`tr-content`}>
                    <div className="tr-title">Workout Settings</div>
                  </div>
                  <div className="tr-icon-group">
                    <a
                      role="button"
                      data-button-type="secondary"
                      data-icon
                      data-icon-only
                      className="edit"
                      href={
                        `/actions/refresh?modal[type]=edit-cycle-settings&cycleId=${cycle._id}&storeType=single-workout` +
                        organizationQuery
                      }
                    >
                      <SvgIcon
                        className="yellow"
                        src="/img/new-icons/settings.svg"
                        alt="edit"
                      />
                    </a>
                  </div>
                </li>
                <li className="tr-Cycle-Program-Item">
                  <div className={`tr-content`}>
                    <div className="tr-title">Publish</div>
                  </div>
                  <div className="tr-icon-group">
                    <input
                      type="checkbox"
                      role="switch"
                      id={`toggle-${cycle._id}`}
                      onClick={(event) => {
                        const url = `/actions/cycle/${
                          event.target.checked ? "publish" : "unpublish"
                        }/${cycle._id}?`;
                        event.stopPropagation();
                        submit(url, {
                          method: "GET",
                          body: {
                            store: true,
                          },
                        });
                      }}
                      checked={isSubscriptionPublished}
                    />
                  </div>
                </li>
                {isFe && isSubscriptionPublished && (
                  <li className="tr-Cycle-Program-Item">
                    <div className={`tr-content`}>
                      <div className="tr-title">Most Popular</div>
                    </div>
                    <div className="tr-icon-group">
                      <button
                        data-button-type="secondary"
                        data-icon
                        data-icon-only
                        className="edit"
                        onClick={(event) => {
                          event.stopPropagation();
                          if (isMostPopular) return;
                          let body = {
                            programId: cycle._id,
                            storeType: cycle.storeType || "single-workout",
                          };
                          if (
                            activeUser.organizationId &&
                            String(activeUserToRequest._id) !==
                              String(activeUser._id)
                          ) {
                            body = {
                              ...body,
                              organizationUserId: activeUserToRequest._id,
                            };
                          }
                          submit("/actions/cycle/store/popular-program", {
                            method: "POST",
                            body,
                          });
                        }}
                      >
                        <SvgIcon
                          classNames="popular"
                          src={
                            isMostPopular
                              ? "/img/new-icons/golden-star.svg"
                              : "/img/new-icons/star.svg"
                          }
                          noFilterOnLight={isMostPopular ? true : false}
                        />
                      </button>
                    </div>
                  </li>
                )}
              </ul>
            )}
          </div>
          {isSubscriptionPublished && notSingleWorkout && (
            <footer className="subscriber-footer">
              <div className="experience">
                <p className="p1">Experience Level</p>
                <div className="experience-bar">
                  <div className="labels">
                    <p className="s3">Beginner</p>
                    <p className="s3">Expert</p>
                  </div>
                  <div className="bar">
                    <div
                      className="status"
                      style={
                        cycle.difficulty
                          ? {
                              width: {
                                Beginner: "33%",
                                Intermediate: "50%",
                                Expert: "100%",
                              }[cycle.difficulty],
                            }
                          : { width: 0 }
                      }
                    />
                  </div>
                </div>
              </div>

              <div>
                <div className="flex gap-2 items-center">
                  <a
                    role="button"
                    data-button-type="outline"
                    href={previewPath}
                  >
                    <span>Preview Program</span>
                  </a>
                  <button
                    data-button-type="secondary"
                    data-icon
                    data-icon-only
                    onClick={() => {
                      submit(`/actions/refresh/?`, {
                        method: "GET",
                        body: {
                          "modal[type]": "learn-more",
                          cycleId: cycle._id,
                        },
                      });
                    }}
                  >
                    <SvgIcon
                      alt="info"
                      src="/img/new-icons/w-info-circle.svg"
                    />
                  </button>
                  {isFe && isSubscriptionPublished && (
                    <button
                      data-button-type="secondary"
                      data-icon
                      data-icon-only
                      className={`most-popular${
                        !isMostPopular ? " small" : ""
                      }`}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (isMostPopular) return;
                        let body = {
                          programId: cycle._id,
                          storeType: cycle.storeType || "programs",
                        };
                        if (
                          activeUser.organizationId &&
                          String(activeUserToRequest._id) !==
                            String(activeUser._id)
                        ) {
                          body = {
                            ...body,
                            organizationUserId: activeUserToRequest._id,
                          };
                        }
                        submit("/actions/cycle/store/popular-program", {
                          method: "POST",
                          body,
                        });
                      }}
                    >
                      <SvgIcon
                        alt="popular"
                        src={
                          isMostPopular
                            ? "/img/new-icons/golden-star.svg"
                            : "/img/new-icons/star.svg"
                        }
                        noFilterOnLight={isMostPopular ? true : false}
                      />
                    </button>
                  )}
                </div>

                {activeUserToRequest.subscription && (
                  <span>
                    <a href={addToCalenderPath}>
                      Add to Calendar
                      <img
                        className="icon-green"
                        alt="preview"
                        src="/img/svg/calendar-alt.svg"
                      />
                    </a>
                  </span>
                )}
                <input
                  type="checkbox"
                  role="switch"
                  id={`toggle-${cycle._id}`}
                  onClick={(event) => {
                    const url = `/actions/cycle/${
                      event.target.checked ? "publish" : "unpublish"
                    }/${cycle._id}?`;
                    event.stopPropagation();
                    submit(url, {
                      method: "GET",
                      body: {
                        store: true,
                      },
                    });
                  }}
                  checked={isSubscriptionPublished}
                />
              </div>
            </footer>
          )}

          {!isSubscriptionPublished && notSingleWorkout && (
            <footer>
              {String(activeUserToRequest._id) ===
                String(get(cycle, "createdBy._id", cycle.createdBy)) && (
                <button
                  className="new-program"
                  data-button-type="text"
                  data-icon
                  onClick={() => {
                    if (this.state.blockSubmited) return;
                    this.setState({ blockSubmited: true });
                    submit(
                      `/actions/cycle/${cycle._id}/?proxyAthlete=${query.athlete}${organizationQuery}`,
                      {
                        method: "POST",
                      }
                    );
                  }}
                >
                  <img alt="add" src="/img/new-icons/add-gradient-icon.svg" />
                  <span className=" font-semibold">Add Block</span>
                </button>
              )}

              {inCoachMode || isSubscription || userMode ? (
                <div className="tr-icon-group">
                  {ListIcon.map(
                    ({
                      src,
                      alt,
                      id,
                      url,
                      message,
                      show,
                      showForUser,
                      colorClass,
                    }) => {
                      return (
                        show &&
                        !(!showForUser && userMode) && (
                          <ToolTip
                            id={`${cycle._id}-${id}`}
                            body={message}
                            key={`${cycle._id}-${id}`}
                            float={false}
                          >
                            <a href={url}>
                              <div
                                className="bg-[--white-05] p-1 rounded-[--border-radius-md] hover:bg-[--white-20] cursor-pointer"
                                id="img-footer-cycle-card-container"
                              >
                                <SvgIcon
                                  className={colorClass ? colorClass : ""}
                                  src={src}
                                  alt={alt}
                                  noFilterOnLight={id === "delete-program"}
                                />
                              </div>
                            </a>
                          </ToolTip>
                        )
                      );
                    }
                  )}
                  {isSubscription && (
                    <input
                      type="checkbox"
                      role="switch"
                      id={`toggle-${cycle._id}`}
                      onClick={(event) => {
                        const url = `/actions/cycle/${
                          event.target.checked ? "publish" : "unpublish"
                        }/${cycle._id}?`;
                        event.stopPropagation();
                        submit(url, {
                          method: "GET",
                          body: {
                            store: true,
                          },
                        });
                      }}
                      checked={isSubscriptionPublished}
                    />
                  )}
                </div>
              ) : (
                <b>{`${cycle.programs.length} Block${
                  cycle.programs.length != 1 ? "s" : ""
                }`}</b>
              )}
            </footer>
          )}

          {!notSingleWorkout && !isSubscriptionPublished && (
            <footer className="!justify-center">
              <button
                className="new-program"
                data-button-type="text"
                data-icon
                onClick={() => {
                  if (this.state.blockSubmited) return;
                  this.setState({ blockSubmited: true });
                  submit(
                    `${parentPath}/edit-program/${cycle._id}${organizationQuery}`,
                    {
                      method: "GET",
                      body: {
                        program: 1,
                        athlete: query.athlete,
                      },
                    }
                  );
                }}
              >
                <span className=" font-semibold">Edit Program</span>
              </button>
            </footer>
          )}
        </div>
      </article>
    );
  }
}

CycleCard.contextTypes = { locals: PropTypes.object };

export default CycleCard;

const CycleHeader = ({ cycle, isSubscriptionPublished }) => {
  return (
    <header>
      {cycle.difficulty && !isSubscriptionPublished && (
        <SvgIcon
          src={`/img/new-icons/signal-${cycle.difficulty.toLowerCase()}.svg`}
          alt="signal"
          noFilterOnLight={true}
        />
      )}
      <h2 className={`title ${isSubscriptionPublished && "title-published"}`}>
        {cycle.name}
      </h2>
    </header>
  );
};

const CycleTags = ({ cycle, state, toggleTags }) => {
  return (
    <div className={`tags`}>
      {cycle.goals?.length > 0 && (
        <>
          <ul className={state.expanded ? "opened" : ""}>
            {cycle.goals.map(({ title }, idx) => (
              <li className="chip info" key={`${cycle._id}-tag-${idx}}`}>
                {title}
              </li>
            ))}
          </ul>

          {cycle.goals.length >= 3 && (
            <SvgIcon
              src={`/img/new-icons/${
                state.expanded ? "arrow-square-up" : "arrow-square-down"
              }.svg`}
              alt="more"
              onClick={toggleTags}
            />
          )}
        </>
      )}
    </div>
  );
};
